"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, Send } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FormularioDeContacto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`py-24 bg-light-background transition-all duration-[var(--duration-slow)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="container mx-auto px-4 max-w-xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground-light mb-4">
            Contacto
          </h2>
          <p className="text-lg text-muted-foreground">Completa el formulario y me pondré en contacto contigo para agendar una sesión de exploración gratuita.
A partir de ahí, si tiene sentido, definiremos juntos el formato de acompañamiento.</p>
        </div>

        <FormProvider className="bg-white rounded-lg shadow-medium p-8" formId="contact-form-contact-page" sectionName="formulario-de-contacto" defaultValues={{
        nombre: "",
        email: "",
        telefono: "",
        mensaje: ""
      }} validationRules={{
        nombre: {
          required: true,
          minLength: 2,
          maxLength: 100
        },
        email: {
          required: true,
          pattern: "email"
        },
        telefono: {
          required: true,
          minLength: 9,
          maxLength: 20
        },
        mensaje: {
          required: true,
          minLength: 10,
          maxLength: 1000
        }
      }} submitText="Enviar mensaje" successMessage="¡Gracias! He recibido tu mensaje y me pondré en contacto contigo pronto." errorMessage="No se pudo enviar el formulario. Por favor, intenta de nuevo.">
          <ContactFormContent />
        </FormProvider>
      </div>
    </section>;
}
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-8">
        <div className="mb-6 p-6 bg-primary-light/50 border-2 border-primary rounded-lg">
          <p className="text-lg font-semibold text-primary-dark">{successMessage}</p>
        </div>
        <Button onClick={resetForm} variant="outline" className="hover-lift">
          Enviar otro mensaje
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="nombre" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        },
        maxLength: {
          value: 100,
          message: "Máximo 100 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nombre completo</FormLabel>
              <FormControl>
                <Input placeholder="Tu nombre" className="focus:shadow-[inset_0_0_0_2px_hsl(var(--color-primary))] transition-shadow duration-[var(--duration-medium)]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "El email es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Correo electrónico</FormLabel>
              <FormControl>
                <Input type="email" placeholder="tu@email.com" className="focus:shadow-[inset_0_0_0_2px_hsl(var(--color-primary))] transition-shadow duration-[var(--duration-medium)]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="telefono" rules={{
        required: "El teléfono es obligatorio",
        minLength: {
          value: 9,
          message: "Mínimo 9 caracteres"
        },
        pattern: {
          value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
          message: "Formato de teléfono inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Teléfono</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+34 600 123 456" className="focus:shadow-[inset_0_0_0_2px_hsl(var(--color-primary))] transition-shadow duration-[var(--duration-medium)]" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="mensaje" rules={{
        required: "El mensaje es obligatorio",
        minLength: {
          value: 10,
          message: "Mínimo 10 caracteres"
        },
        maxLength: {
          value: 1000,
          message: "Máximo 1000 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Mensaje</FormLabel>
              <FormControl>
                <textarea placeholder="Cuéntame qué te gustaría trabajar en nuestras sesiones..." rows={5} className="flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-shadow outline-none placeholder:text-muted-foreground focus:shadow-[inset_0_0_0_2px_hsl(var(--color-primary))] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-accent-light/50 border-2 border-accent rounded-lg">
            <p className="text-accent-dark font-medium">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full btn-primary h-12 text-base font-semibold">Solicitar sesión gratuita
      </Button>
      </div>
    </Form>;
}